<template>
	<div>
		<navigator></navigator>
		<!-- <div class="navigationBg">
			<div class="navigation">
				<h1>
					<img class="logo" alt="筑橙科技" src="../resource/images/logo.svg">
				</h1>
				<div class="navigator">
					<router-link to="/" class="navigatorText">首页
						<div class="block"></div>
					</router-link>
					<div @click="reminder()" class="navigatorText">产品中心
						<div class="block"></div>
					</div>
					<router-link to="/example01" class="navigatorText">应用案例
						<div class="block"></div>
					</router-link>
					<router-link to="/news01" class="navigatorText">筑橙新闻
						<div class="block"></div>
					</router-link>
					<router-link to="/aboutUs" class="navigatorText">关于我们
						<div class="block"></div>
					</router-link>
					<div class="navigatorText active">在线联系
						<div class="block activeBlock"></div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="localhost">
			<div class="localhostText">首页/<span style="color:#333;">在线联系</span></div>
		</div>
		<div class="form">
			<div class="onlineContact">在线联系</div>
			<div class="inputDiv">
				<div class="inputTitle"><span>*</span>姓名</div>
				<input class="input" type="text">
			</div>
			<div class="inputDiv">
				<div class="inputTitle"><span>*</span>手机号</div>
				<input class="input" type="number">
			</div>
			<div class="inputDiv">
				<div class="inputTitle"><span>*</span>城市</div>
				<input class="input" type="text">
			</div>
			<div class="inputDiv" style="margin-bottom:70px;">
				<div class="inputTitle">留言内容</div>
				<textarea style="width: 437px;height: 201px;" class="input"></textarea>
			</div>
			<div class="submit">立即提交</div>
		</div>
		<foot></foot>
	</div>
</template>

<script>
	import foot from "../components/foot"
	import navigator from "../components/navigator"
	export default {
		components: {
			foot,
			navigator
		},
		name: 'contactOur',
		data() {
			return {

			}
		},
		methods: {
			reminder() {
				this.hint.hint()
			}
		}
	}
</script>

<style scoped>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}

	.submit {
		margin-bottom: 100px;
		margin-left: 64px;
		color: #fff;
		text-align: center;
		width: 524px;
		line-height: 65px;
		background: linear-gradient(309deg, #ea5b24 6%, #ea7a24 94%);
		border-radius: 8px;
		font-size: 20px;
	}

	.input {
		margin-left: 7px;
		width: 437px;
		height: 54px;
		border: 1px solid #ddd;
		border-radius: 8px;
	}

	.input:active,
	.input:focus {
		background: none;
		outline: none;
	}

	.inputDiv {
		margin-top: 30px;
		box-sizing: border-box;
		padding-left: 15px;
		display: flex;
		align-items: center;
	}

	.inputTitle {
		/* line-height: 54px;
		font-size: 20px;
		color: #333;
		width: 4em; */


		line-height: 54px;
		font-size: 20px;
		color: #333;
		min-width: 100px;
		text-align: right;
		margin-right: 20px;
	}

	.inputTitle span {
		color: red;
	}

	.onlineContact {
		margin-bottom: 57px;
		margin-top: 70px;
		line-height: 56px;
		font-size: 40px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
		padding-bottom: 30px;
		border-bottom: 1px solid #eee;
	}

	.form {
		width: 1040px;
		margin: 0 auto;
	}

	.localhostText {
		width: 1040px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
		margin: 0 auto;
	}

	.localhost {
		height: 85px;
		display: flex;
		align-items: center;
		background-color: #f6f7f7;
	}

	.localhostText {
		width: 1200px;
		margin: 0 auto;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
	}

	.title {
		line-height: 56px;
		font-size: 40px;
		font-family: PingFang SC, PingFang SC-Heavy;
		font-weight: 800;
		text-align: left;
		color: #333;
		margin-top: 60px;
	}

	.logo {
		width: 154px;
		height: 38px;
	}

	.navigation {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.navigator {
		display: flex;
		align-items: center;
	}

	.navigatorText {
		line-height: 25px;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #fff;
		margin-left: 60px;
		cursor: pointer;
		transition: all .3s;
		position: relative;
	}

	.navigatorText:nth-child(1) {
		margin-left: 0px;
	}

	.navigatorText:hover {
		color: #EA5B24;
	}

	.block {
		position: absolute;
		/* width: 33px; */
		width: 100%;
		height: 2px;
		background-color: #fff;
		transition: all .3s;
		left: 0;
		bottom: -5px;
		opacity: 0;
	}

	.navigatorText:hover .block {
		background-color: #EA5B24;
		opacity: 1;
	}

	.navigationBg {
		width: 100%;
		background-color: rgba(0, 0, 0, 0.66);
		display: flex;
		justify-content: center;
		/* position: absolute;
		left: 0;
		top: 0; */
	}

	.navigatorText {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/pages/contactOur.vue